// Data-viz fill colours for the three slot-fill provenances, shared by the
// matrix, the build-up chart and the aggregate footer so the drill-down reads
// as one picture.
//
// Values are Predico brand/accent token hexes (see
// documentation/internal/VISUAL_IDENTITY.md §2.1) plus a neutral slate for the
// "borrowed" cross-horizon class. They live here as JS constants — like
// About.js RANKING_COLORS — because the cells need per-cell alpha that Tailwind
// utility classes can't express (the §2.4 data-viz exception).
import { SOURCES } from './dayDetailMath';

export const SOURCE_COLOR = {
  [SOURCES.LIVE]: '#05788a',          // brand-600  — your own fresh forecast
  [SOURCES.FWD_FILL]: '#ff7926',      // accent-500 — carried forward from an earlier gate
  [SOURCES.CROSS_HORIZON]: '#64748b', // slate-500  — borrowed from another horizon
};

export const SOURCE_LABEL = {
  [SOURCES.LIVE]: 'Live submission',
  [SOURCES.FWD_FILL]: 'Intraday forward-fill',
  [SOURCES.CROSS_HORIZON]: 'Cross-horizon substitute',
  [SOURCES.MISSING]: 'Missing — no fill source',
  [SOURCES.NOT_APPLICABLE]: 'Not applicable — no session at this gate',
};

// Not-applicable slots (no intraday session at that gate). Rendered as a
// diagonal HATCH rather than a flat shade: a flat faint slate is
// indistinguishable from a low-error cross-horizon cell (whose alpha floors
// near 0.18), so we differentiate by PATTERN instead of hue/brightness. The
// hatch reads as "out of scope" and never collides with a solid filled cell.
export const NOT_APPLICABLE_COLOR = '#cbd5e1'; // slate-300 (legacy flat fallback)
export const NOT_APPLICABLE_HATCH =
  'repeating-linear-gradient(45deg, rgba(148,163,184,0.55) 0, ' +
  'rgba(148,163,184,0.55) 2px, rgba(148,163,184,0) 2px, rgba(148,163,184,0) 6px)';

// "#rrggbb" + alpha[0..1] → "rgba(r, g, b, a)".
export function withAlpha(hex, alpha) {
  const h = String(hex).replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
